import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ClientResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/portal/auth/reset-password", { token, new_password: password });
      setDone(true); setTimeout(() => navigate("/client/login"), 1500);
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  if (!token) return <AuthShell title="Invalid link" subtitle="This reset link is missing or invalid." />;
  if (done) return <AuthShell title="Password reset" subtitle="Your password has been reset. Redirecting to sign in…" />;

  return (
    <AuthShell title="Set a new password" subtitle="Choose a new password for your client portal.">
      <form onSubmit={submit} className="space-y-4" data-testid="client-reset-form">
        <div><Label className="text-[#D4D4D8] mb-1.5 block">New password</Label>
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="client-reset-password" placeholder="At least 6 characters" className="bg-[#121214] border-white/10 text-white h-11" /></div>
        <div><Label className="text-[#D4D4D8] mb-1.5 block">Confirm password</Label>
          <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
            data-testid="client-reset-confirm" placeholder="Re-enter password" className="bg-[#121214] border-white/10 text-white h-11" /></div>
        {error && <p className="text-sm text-red-400">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="client-reset-submit"
          className="w-full fv-gold-gradient text-[#0A0A0B] font-semibold h-11 rounded-lg hover:opacity-90">
          {loading ? "Resetting…" : "Reset password"}</Button>
      </form>
      <Link to="/client/login" className="block text-center text-sm text-[#A1A1AA] mt-6 hover:text-white">Back to sign in</Link>
    </AuthShell>
  );
}
